import styled from 'styled-components';

export const CategoryGridGeneralItemSection = styled.section`
  padding: 4px;
  background-color: #f9fafb;
  text-align: center;
  max-width: 720px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  .sectionTopImage {
    position: relative;
    aspect-ratio: 336/80;
    padding: 12px;

    @media (max-width: 720px) {
      aspect-ratio: ${(prop) => (prop.isForJoyfulPage ? '280/80' : '')};
      margin: ${(prop) => (prop.isForJoyfulPage ? '10px 0' : '')};
    }
  }
  .image {
    border-radius: 8px;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: flex-start;
    align-items: 'center';
    flex-wrap: wrap;
    padding: '2px 1% 0';
    gap: 0px;
    @media (max-width: 720px) {
      gap: '22px';
      grid-template-columns: repeat(3, 1fr);
      align-items: flex-start;
      padding: '0 12px';
    }
  }
  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: hsl(0deg, 0%, 0%, 18%);
  }
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
